// SwissAlpenLine translations — 5 languages
// EN default. Keep strings concise and sober.

export const LANGS = [
  { code: "de", label: "DE", full: "Deutsch" },
  { code: "en", label: "EN", full: "English" },
  { code: "fr", label: "FR", full: "Français" },
  { code: "it", label: "IT", full: "Italiano" },
  { code: "pt", label: "PT", full: "Português" },
];

export const T = {
  en: {
    nav: { home: "Home", services: "Services", fleet: "Fleet", partners: "Partners", contact: "Contact", reserve: "Reserve" },
    hero: {
      tagline: "Private transport. Swiss precision.",
      subtitle: "Discreet chauffeur service across Switzerland and neighbouring countries.",
      ctaReserve: "Reserve",
      ctaCalc: "Get a quote",
    },
    calc: {
      title: "Instant fare",
      subtitle: "Enter your route. Compare prices. Reserve in one step.",
      origin: "From",
      destination: "To",
      when: "Date & time",
      service: "Service",
      transfer: "Transfer",
      courier: "Courier — Documents",
      childSeats: "Child seats",
      pet: "Pet up to 8 kg",
      petNone: "No pet",
      petNo: "Pet, no carrier",
      petCarrier: "Pet, carrier provided",
      submit: "Calculate",
      calculating: "Calculating…",
      distance: "Distance",
      duration: "Approx. duration",
      night: "Night rate applied",
      weekend: "Weekend rate applied",
      compare: "Market comparison",
      us: "SwissAlpenLine",
      taxi: "Taxi (Switzerland)",
      uber: "Premium ride-hail (Black tier)",
      other: "Other private chauffeur",
      train: "Train / public transport",
      savings: "You save",
      premium: "Premium over train, but you gain",
      reasons: ["Door-to-door discretion", "Punctuality", "Immaculate cabin", "Women-safe policy", "Multilingual chauffeur"],
      reserveNow: "Reserve this trip",
      currencyNote: "Prices in CHF. On-board payment also accepted in USD / EUR (CHF-favoured conversion).",
    },
    about: {
      title: "About",
      body: "SwissAlpenLine is a private chauffeur line operating between Lucerne, Basel, Zurich, Grindelwald and neighbouring France. We serve executives, private travellers and hotel guests who value discretion, punctuality and calm.",
      values: [
        { k: "Discretion", v: "Silent cabin, no logos on the vehicle." },
        { k: "Punctuality", v: "Swiss standard — always on time." },
        { k: "Inclusion", v: "Woman-safe service. All faiths, ethnicities and orientations welcome." },
        { k: "Precision", v: "Every route, every hour, prepared in advance." },
      ],
    },
    services: {
      title: "Services",
      transfer: { title: "Airport & point-to-point transfers", body: "EuroAirport Basel-Mulhouse-Freiburg, Zurich, Geneva, Lucerne, Interlaken, plus cross-border cities." },
      fullDay: { title: "Chauffeur for a day", body: "CHF 980 for 8 hours. CHF 110 per extra hour. Region of your choice.", cta: "Learn more" },
      hourly:  { title: "Chauffeur by the hour", body: "Executive chauffeur on demand. Minimum 2 hours. Multi-stop within city.", cta: "Book by the hour" },
      courier: { title: "Discreet courier — hand-to-hand documents", body: "Confidential document delivery across Europe. Priority handling. Night hours available (22:00 – 06:00).", cta: "Discover" },
    },
    fleet: {
      title: "Fleet — N°1",
      car: "BYD Seal U DM-i (2025)",
      description: "Plug-in hybrid SUV. Whisper-quiet cabin. Panoramic sky roof. Ambient light. On-board Infinity® sound system with 10 speakers including subwoofer, ambient light synced with the music, and NVH noise-cancelling cabin technology. On-board Wi-Fi (subject to Swiss network availability).",
      trunk: "Luggage capacity",
      trunkNote: "Trunk 552 L (up to 1440 L folded). Combinations: 2 × 23 kg + 1 × 8 kg cabin, or 4 × 8 kg cabin, or 3 large + 2 cabin.",
      soon: "Expansion of the fleet planned. N°1 today, more to follow.",
    },
    partners: {
      title: "Partners",
      subtitle: "Exclusive codes for our business partners and their guests.",
      empty: "Partner slots reserved for hotels, restaurants, pharmaceutical companies, insurance & credit institutions.",
      voucher: "Enter voucher code",
      apply: "Apply",
      applied: "Voucher applied",
    },
    booking: {
      title: "Reservation",
      subtitle: "Confirm within moments. All fields are required unless marked optional.",
      service: "Service",
      transfer: "Transfer",
      fullDay: "Chauffeur for a day",
      courier: "Courier — Documents",
      origin: "Pickup",
      destination: "Drop-off",
      when: "Pickup date & time",
      passengers: "Passengers",
      childSeats: "Child seats",
      childSeatsNote: "Children under 5: please bring your own seat.",
      pet: "Pet",
      luggage: "Luggage",
      luggagePh: "Number and size of bags",
      name: "Full name",
      email: "Email",
      phone: "Phone (+41 or international)",
      notes: "Notes",
      notesPh: "Flight number, special requests…",
      submit: "Send reservation",
      sending: "Sending…",
      success: "Reservation received. We will confirm shortly by WhatsApp or email.",
      errors: { required: "Please fill in all required fields." },
    },
    contact: {
      title: "Contact",
      whatsapp: "WhatsApp",
      phone: "Phone",
      email: "Email",
      hours: "Reservations · 09:00 – 19:30 CET, 7 days a week",
    },
    footer: {
      rights: "All rights reserved.",
      qr: "Scan to reserve",
      langs: "Language",
    },
    kiosk: {
      title: "On-board menu",
      about: "About us",
      explore: "Explore the region",
      reserve: "Reserve",
    },
    common: {
      chf: "CHF",
      km: "km",
      min: "min",
      hour: "h",
      moreInfo: "More",
      back: "Back",
    },
  },

  pt: {
    nav: { home: "Início", services: "Serviços", fleet: "Frota", partners: "Parceiros", contact: "Contacto", reserve: "Reservar" },
    hero: {
      tagline: "Transporte privado. Precisão suíça.",
      subtitle: "Serviço discreto de chauffeur na Suíça e países vizinhos.",
      ctaReserve: "Reservar",
      ctaCalc: "Calcular viagem",
    },
    calc: {
      title: "Preço instantâneo",
      subtitle: "Escolha o trajeto. Compare valores. Reserve num só passo.",
      origin: "De",
      destination: "Para",
      when: "Data e hora",
      service: "Serviço",
      transfer: "Transfer",
      courier: "Courier — Documentos",
      childSeats: "Cadeiras de criança",
      pet: "Animal até 8 kg",
      petNone: "Sem animal",
      petNo: "Animal, sem transportadora",
      petCarrier: "Animal, com transportadora",
      submit: "Calcular",
      calculating: "A calcular…",
      distance: "Distância",
      duration: "Duração aprox.",
      night: "Tarifa noturna aplicada",
      weekend: "Tarifa fim-de-semana aplicada",
      compare: "Comparação de mercado",
      us: "SwissAlpenLine",
      taxi: "Taxi (Suíça)",
      uber: "App premium de mobilidade",
      other: "Outro chauffeur privado",
      train: "Comboio / transportes públicos",
      savings: "Poupa",
      premium: "Preço acima do comboio, mas ganha",
      reasons: ["Discrição porta-a-porta", "Pontualidade", "Cabine impecável", "Serviço woman-safe", "Chauffeur multilingue"],
      reserveNow: "Reservar esta viagem",
      currencyNote: "Preços em CHF. Pagamento a bordo também em USD / EUR (conversão favorável ao CHF).",
    },
    about: {
      title: "Sobre",
      body: "A SwissAlpenLine é uma linha privada de chauffeur entre Lucerna, Basileia, Zurique, Grindelwald e França vizinha. Servimos executivos, viajantes privados e hóspedes de hotéis que valorizam discrição, pontualidade e calma.",
      values: [
        { k: "Discrição", v: "Cabine silenciosa, sem logótipos no veículo." },
        { k: "Pontualidade", v: "Padrão suíço — sempre à hora." },
        { k: "Inclusão", v: "Serviço woman-safe. Todas as religiões, etnias e orientações são bem-vindas." },
        { k: "Precisão", v: "Cada rota, cada hora, preparada com antecedência." },
      ],
    },
    services: {
      title: "Serviços",
      transfer: { title: "Transfers aeroporto e ponto-a-ponto", body: "EuroAirport Basel-Mulhouse-Freiburg, Zurique, Genebra, Lucerna, Interlaken e cidades transfronteiriças." },
      fullDay: { title: "Chauffeur por um dia", body: "CHF 980 por 8 horas. CHF 110 por hora extra. Região à sua escolha.", cta: "Saber mais" },
      hourly:  { title: "Chauffeur à hora", body: "Chauffeur executivo a pedido. Mínimo 2 horas. Multi-paragem na mesma cidade.", cta: "Reservar à hora" },
      courier: { title: "Courier discreto — documentos mão-a-mão", body: "Entrega confidencial de documentos por toda a Europa. Prioridade absoluta. Serviço noturno disponível (22h00 – 06h00).", cta: "Descobrir" },
    },
    fleet: {
      title: "Frota — N°1",
      car: "BYD Seal U DM-i (2025)",
      description: "SUV híbrido. Cabine silenciosa. Teto panorâmico. Iluminação ambiente. Wi-Fi a bordo (sujeito à disponibilidade de rede suíça).",
      trunk: "Capacidade de bagageira",
      trunkNote: "Bagageira 552 L (até 1440 L rebatida). Referência: 3 malas grandes + 2 malas de cabine, ou 4 malas médias.",
      soon: "Expansão da frota planeada. Hoje N°1, em breve mais.",
    },
    partners: {
      title: "Parceiros",
      subtitle: "Códigos exclusivos para parceiros business e seus hóspedes.",
      empty: "Lugares reservados a hotéis, restaurantes, farmacêuticas, seguradoras e instituições de crédito.",
      voucher: "Introduza código voucher",
      apply: "Aplicar",
      applied: "Voucher aplicado",
    },
    booking: {
      title: "Reserva",
      subtitle: "Confirmação em minutos. Todos os campos são obrigatórios exceto quando indicado.",
      service: "Serviço",
      transfer: "Transfer",
      fullDay: "Chauffeur por um dia",
      courier: "Courier — Documentos",
      origin: "Recolha",
      destination: "Destino",
      when: "Data e hora da recolha",
      passengers: "Passageiros",
      childSeats: "Cadeiras de criança",
      childSeatsNote: "Crianças até 5 anos: por favor, traga a sua própria cadeira.",
      pet: "Animal",
      luggage: "Bagagem",
      luggagePh: "Número e tamanho das malas",
      name: "Nome completo",
      email: "Email",
      phone: "Telefone (+41 ou internacional)",
      notes: "Notas",
      notesPh: "Número de voo, pedidos especiais…",
      submit: "Enviar reserva",
      sending: "A enviar…",
      success: "Reserva recebida. Confirmaremos brevemente por WhatsApp ou email.",
      errors: { required: "Preencha todos os campos obrigatórios." },
    },
    contact: {
      title: "Contacto",
      whatsapp: "WhatsApp",
      phone: "Telefone",
      email: "Email",
      hours: "Reservas · 09:00 – 19:30 CET, 7 dias por semana",
    },
    footer: { rights: "Todos os direitos reservados.", qr: "Digitalize para reservar", langs: "Idioma" },
    kiosk: { title: "Menu a bordo", about: "Sobre nós", explore: "Explorar a região", reserve: "Reservar" },
    common: { chf: "CHF", km: "km", min: "min", hour: "h", moreInfo: "Mais", back: "Voltar" },
  },

  de: {
    nav: { home: "Start", services: "Services", fleet: "Flotte", partners: "Partner", contact: "Kontakt", reserve: "Reservieren" },
    hero: {
      tagline: "Privater Transport. Schweizer Präzision.",
      subtitle: "Diskreter Chauffeurdienst zwischen der Schweiz und den Nachbarländern.",
      ctaReserve: "Reservieren",
      ctaCalc: "Preis berechnen",
    },
    calc: {
      title: "Sofortpreis",
      subtitle: "Route wählen. Preise vergleichen. In einem Schritt buchen.",
      origin: "Von",
      destination: "Nach",
      when: "Datum & Uhrzeit",
      service: "Service",
      transfer: "Transfer",
      courier: "Kurier — Dokumente",
      childSeats: "Kindersitze",
      pet: "Tier bis 8 kg",
      petNone: "Kein Tier",
      petNo: "Tier, ohne Transportbox",
      petCarrier: "Tier, mit Transportbox",
      submit: "Berechnen",
      calculating: "Wird berechnet…",
      distance: "Distanz",
      duration: "Ca. Dauer",
      night: "Nachttarif angewendet",
      weekend: "Wochenendtarif angewendet",
      compare: "Marktvergleich",
      us: "SwissAlpenLine",
      taxi: "Taxi (Schweiz)",
      uber: "Premium-Rideshare (Black-Klasse)",
      other: "Anderer Privatchauffeur",
      train: "Bahn / öffentlicher Verkehr",
      savings: "Sie sparen",
      premium: "Aufpreis gegenüber Zug — Sie gewinnen",
      reasons: ["Diskretion von Tür zu Tür", "Pünktlichkeit", "Makellose Kabine", "Woman-safe Service", "Mehrsprachiger Chauffeur"],
      reserveNow: "Diese Fahrt reservieren",
      currencyNote: "Preise in CHF. Zahlung an Bord auch in USD / EUR (mit CHF-günstiger Umrechnung).",
    },
    about: {
      title: "Über uns",
      body: "SwissAlpenLine ist eine private Chauffeurlinie zwischen Luzern, Basel, Zürich, Grindelwald und dem benachbarten Frankreich. Wir bedienen Führungskräfte, Privatreisende und Hotelgäste, die Diskretion, Pünktlichkeit und Ruhe schätzen.",
      values: [
        { k: "Diskretion", v: "Ruhige Kabine, keine Logos am Fahrzeug." },
        { k: "Pünktlichkeit", v: "Schweizer Standard — stets rechtzeitig." },
        { k: "Inklusion", v: "Woman-safe. Alle Glaubensrichtungen, Herkünfte und Orientierungen willkommen." },
        { k: "Präzision", v: "Jede Route, jede Stunde — vorbereitet." },
      ],
    },
    services: {
      title: "Services",
      transfer: { title: "Flughafen- & Punkt-zu-Punkt-Transfers", body: "EuroAirport Basel-Mulhouse-Freiburg, Zürich, Genf, Luzern, Interlaken sowie grenznahen Städten." },
      fullDay: { title: "Chauffeur für einen Tag", body: "CHF 980 für 8 Stunden. CHF 110 pro zusätzliche Stunde. Region Ihrer Wahl.", cta: "Mehr erfahren" },
      hourly:  { title: "Chauffeur stundenweise", body: "Executive-Chauffeur auf Abruf. Mindestens 2 Stunden. Mehrere Halte in derselben Stadt.", cta: "Stundenweise buchen" },
      courier: { title: "Diskreter Kurier — Dokumente von Hand", body: "Vertrauliche Dokumentenzustellung in ganz Europa. Priorität. Nachtdienst (22:00 – 06:00).", cta: "Entdecken" },
    },
    fleet: {
      title: "Flotte — N°1",
      car: "BYD Seal U DM-i (2025)",
      description: "Hybrid-SUV. Ruhige Kabine. Panoramadach. Ambientebeleuchtung. WLAN an Bord (abhängig von der Netzverfügbarkeit in der Schweiz).",
      trunk: "Kofferraumvolumen",
      trunkNote: "Kofferraum 552 L (bis 1440 L umgeklappt). Richtwert: 3 grosse Koffer + 2 Kabinentaschen, oder 4 mittlere Koffer.",
      soon: "Erweiterung der Flotte geplant. Heute N°1, weitere folgen.",
    },
    partners: {
      title: "Partner",
      subtitle: "Exklusive Codes für unsere Business-Partner und deren Gäste.",
      empty: "Plätze reserviert für Hotels, Restaurants, Pharma, Versicherer und Kreditinstitute.",
      voucher: "Voucher-Code eingeben",
      apply: "Anwenden",
      applied: "Voucher angewendet",
    },
    booking: {
      title: "Reservation",
      subtitle: "Bestätigung innerhalb weniger Minuten. Alle Felder sind erforderlich, sofern nicht anders angegeben.",
      service: "Service",
      transfer: "Transfer",
      fullDay: "Chauffeur für einen Tag",
      courier: "Kurier — Dokumente",
      origin: "Abholung",
      destination: "Ziel",
      when: "Abholzeit",
      passengers: "Passagiere",
      childSeats: "Kindersitze",
      childSeatsNote: "Kinder unter 5 Jahren: bitte eigenen Sitz mitbringen.",
      pet: "Tier",
      luggage: "Gepäck",
      luggagePh: "Anzahl und Grösse der Taschen",
      name: "Vollständiger Name",
      email: "E-Mail",
      phone: "Telefon (+41 oder international)",
      notes: "Anmerkungen",
      notesPh: "Flugnummer, besondere Wünsche…",
      submit: "Reservation senden",
      sending: "Wird gesendet…",
      success: "Reservation eingegangen. Wir bestätigen umgehend per WhatsApp oder E-Mail.",
      errors: { required: "Bitte alle Pflichtfelder ausfüllen." },
    },
    contact: {
      title: "Kontakt",
      whatsapp: "WhatsApp",
      phone: "Telefon",
      email: "E-Mail",
      hours: "Reservationen · 09:00 – 19:30 MEZ, 7 Tage die Woche",
    },
    footer: { rights: "Alle Rechte vorbehalten.", qr: "Scannen zum Reservieren", langs: "Sprache" },
    kiosk: { title: "Bord-Menü", about: "Über uns", explore: "Region entdecken", reserve: "Reservieren" },
    common: { chf: "CHF", km: "km", min: "Min.", hour: "h", moreInfo: "Mehr", back: "Zurück" },
  },

  fr: {
    nav: { home: "Accueil", services: "Services", fleet: "Flotte", partners: "Partenaires", contact: "Contact", reserve: "Réserver" },
    hero: {
      tagline: "Transport privé. Précision suisse.",
      subtitle: "Service de chauffeur discret entre la Suisse et les pays voisins.",
      ctaReserve: "Réserver",
      ctaCalc: "Obtenir un tarif",
    },
    calc: {
      title: "Tarif instantané",
      subtitle: "Choisissez votre trajet. Comparez. Réservez en une étape.",
      origin: "De",
      destination: "À",
      when: "Date et heure",
      service: "Service",
      transfer: "Transfert",
      courier: "Courrier — Documents",
      childSeats: "Sièges enfant",
      pet: "Animal jusqu'à 8 kg",
      petNone: "Sans animal",
      petNo: "Animal, sans caisse",
      petCarrier: "Animal, caisse fournie",
      submit: "Calculer",
      calculating: "Calcul…",
      distance: "Distance",
      duration: "Durée approx.",
      night: "Tarif de nuit appliqué",
      weekend: "Tarif week-end appliqué",
      compare: "Comparaison marché",
      us: "SwissAlpenLine",
      taxi: "Taxi (Suisse)",
      uber: "VTC premium (catégorie Black)",
      other: "Autre chauffeur privé",
      train: "Train / transports publics",
      savings: "Vous économisez",
      premium: "Supplément vs train — vous gagnez",
      reasons: ["Discrétion porte-à-porte", "Ponctualité", "Cabine impeccable", "Service woman-safe", "Chauffeur multilingue"],
      reserveNow: "Réserver ce trajet",
      currencyNote: "Prix en CHF. Paiement à bord aussi en USD / EUR (conversion favorable au CHF).",
    },
    about: {
      title: "À propos",
      body: "SwissAlpenLine est une ligne privée de chauffeur entre Lucerne, Bâle, Zurich, Grindelwald et la France voisine. Nous servons cadres, voyageurs privés et clients d'hôtels qui valorisent discrétion, ponctualité et calme.",
      values: [
        { k: "Discrétion", v: "Cabine silencieuse, sans logo sur le véhicule." },
        { k: "Ponctualité", v: "Standard suisse — toujours à l'heure." },
        { k: "Inclusion", v: "Woman-safe. Toutes religions, origines et orientations bienvenues." },
        { k: "Précision", v: "Chaque itinéraire, chaque heure, préparé." },
      ],
    },
    services: {
      title: "Services",
      transfer: { title: "Transferts aéroport & point-à-point", body: "EuroAirport Bâle-Mulhouse-Freiburg, Zurich, Genève, Lucerne, Interlaken et villes transfrontalières." },
      fullDay: { title: "Chauffeur à la journée", body: "CHF 980 pour 8 heures. CHF 110 par heure supplémentaire. Région de votre choix.", cta: "En savoir plus" },
      courier: { title: "Courrier discret — documents en main propre", body: "Livraison confidentielle de documents partout en Europe. Priorité absolue. Service de nuit (22h00 – 06h00).", cta: "Découvrir" },
    },
    fleet: {
      title: "Flotte — N°1",
      car: "BYD Seal U DM-i (2025)",
      description: "SUV hybride. Cabine silencieuse. Toit panoramique. Éclairage d'ambiance. Wi-Fi à bord (selon disponibilité du réseau suisse).",
      trunk: "Capacité du coffre",
      trunkNote: "Coffre 552 L (jusqu'à 1440 L rabattu). Repère : 3 grandes valises + 2 bagages cabine, ou 4 valises moyennes.",
      soon: "Expansion prévue. N°1 aujourd'hui, d'autres suivront.",
    },
    partners: {
      title: "Partenaires",
      subtitle: "Codes exclusifs pour nos partenaires business et leurs clients.",
      empty: "Places réservées aux hôtels, restaurants, pharma, assureurs et instituts de crédit.",
      voucher: "Entrez le code voucher",
      apply: "Appliquer",
      applied: "Voucher appliqué",
    },
    booking: {
      title: "Réservation",
      subtitle: "Confirmation en quelques minutes. Tous les champs sont requis sauf mention contraire.",
      service: "Service",
      transfer: "Transfert",
      fullDay: "Chauffeur à la journée",
      courier: "Courrier — Documents",
      origin: "Prise en charge",
      destination: "Destination",
      when: "Date & heure de prise en charge",
      passengers: "Passagers",
      childSeats: "Sièges enfant",
      childSeatsNote: "Enfants de moins de 5 ans : merci d'apporter votre propre siège.",
      pet: "Animal",
      luggage: "Bagages",
      luggagePh: "Nombre et taille des bagages",
      name: "Nom complet",
      email: "Email",
      phone: "Téléphone (+41 ou international)",
      notes: "Notes",
      notesPh: "Numéro de vol, demandes particulières…",
      submit: "Envoyer la réservation",
      sending: "Envoi…",
      success: "Réservation reçue. Nous confirmerons rapidement par WhatsApp ou email.",
      errors: { required: "Merci de remplir tous les champs requis." },
    },
    contact: {
      title: "Contact",
      whatsapp: "WhatsApp",
      phone: "Téléphone",
      email: "Email",
      hours: "Réservations · 09:00 – 19:30 CET, 7 jours sur 7",
    },
    footer: { rights: "Tous droits réservés.", qr: "Scannez pour réserver", langs: "Langue" },
    kiosk: { title: "Menu à bord", about: "À propos", explore: "Explorer la région", reserve: "Réserver" },
    common: { chf: "CHF", km: "km", min: "min", hour: "h", moreInfo: "Plus", back: "Retour" },
  },

  it: {
    nav: { home: "Home", services: "Servizi", fleet: "Flotta", partners: "Partner", contact: "Contatti", reserve: "Prenota" },
    hero: {
      tagline: "Trasporto privato. Precisione svizzera.",
      subtitle: "Servizio chauffeur discreto tra Svizzera e paesi confinanti.",
      ctaReserve: "Prenota",
      ctaCalc: "Calcola tariffa",
    },
    calc: {
      title: "Tariffa istantanea",
      subtitle: "Scegli il percorso. Confronta. Prenota in un solo passo.",
      origin: "Da",
      destination: "A",
      when: "Data e ora",
      service: "Servizio",
      transfer: "Transfer",
      courier: "Corriere — Documenti",
      childSeats: "Seggiolini bambino",
      pet: "Animale fino a 8 kg",
      petNone: "Nessun animale",
      petNo: "Animale, senza trasportino",
      petCarrier: "Animale, trasportino fornito",
      submit: "Calcola",
      calculating: "Calcolo in corso…",
      distance: "Distanza",
      duration: "Durata approssimativa",
      night: "Tariffa notturna applicata",
      weekend: "Tariffa weekend applicata",
      compare: "Confronto di mercato",
      us: "SwissAlpenLine",
      taxi: "Taxi (Svizzera)",
      uber: "Ride-hail premium (Black)",
      other: "Altro chauffeur privato",
      train: "Treno / trasporti pubblici",
      savings: "Risparmi",
      premium: "Sovrapprezzo rispetto al treno — guadagni",
      reasons: ["Discrezione porta a porta", "Puntualità", "Cabina impeccabile", "Servizio woman-safe", "Chauffeur multilingue"],
      reserveNow: "Prenota questo viaggio",
      currencyNote: "Prezzi in CHF. Pagamento a bordo anche in USD / EUR (conversione favorevole al CHF).",
    },
    about: {
      title: "Chi siamo",
      body: "SwissAlpenLine è una linea privata di chauffeur tra Lucerna, Basilea, Zurigo, Grindelwald e Francia confinante. Serviamo dirigenti, viaggiatori privati e ospiti di hotel che apprezzano discrezione, puntualità e calma.",
      values: [
        { k: "Discrezione", v: "Cabina silenziosa, nessun logo sul veicolo." },
        { k: "Puntualità", v: "Standard svizzero — sempre in orario." },
        { k: "Inclusione", v: "Woman-safe. Tutte le fedi, etnie e orientamenti benvenuti." },
        { k: "Precisione", v: "Ogni tratta, ogni ora, preparata in anticipo." },
      ],
    },
    services: {
      title: "Servizi",
      transfer: { title: "Transfer aeroporto & punto-punto", body: "EuroAirport Basilea-Mulhouse-Friburgo, Zurigo, Ginevra, Lucerna, Interlaken e città di confine." },
      fullDay: { title: "Chauffeur per un giorno", body: "CHF 980 per 8 ore. CHF 110 per ora extra. Regione a scelta.", cta: "Scopri" },
      courier: { title: "Corriere discreto — documenti a mano", body: "Consegna confidenziale in tutta Europa. Priorità assoluta. Servizio notturno (22:00 – 06:00).", cta: "Scopri" },
    },
    fleet: {
      title: "Flotta — N°1",
      car: "BYD Seal U DM-i (2025)",
      description: "SUV ibrido. Cabina silenziosa. Tetto panoramico. Illuminazione ambient. Wi-Fi a bordo (soggetto alla disponibilità della rete svizzera).",
      trunk: "Capacità bagagliaio",
      trunkNote: "Bagagliaio 552 L (fino a 1440 L abbattuto). Riferimento: 3 valigie grandi + 2 bagagli cabina, o 4 valigie medie.",
      soon: "Espansione della flotta prevista. Oggi N°1, presto di più.",
    },
    partners: {
      title: "Partner",
      subtitle: "Codici esclusivi per i nostri partner business e i loro ospiti.",
      empty: "Posti riservati a hotel, ristoranti, farmaceutiche, assicurazioni e istituti di credito.",
      voucher: "Inserisci codice voucher",
      apply: "Applica",
      applied: "Voucher applicato",
    },
    booking: {
      title: "Prenotazione",
      subtitle: "Conferma in pochi minuti. Tutti i campi sono richiesti se non indicato diversamente.",
      service: "Servizio",
      transfer: "Transfer",
      fullDay: "Chauffeur per un giorno",
      courier: "Corriere — Documenti",
      origin: "Ritiro",
      destination: "Destinazione",
      when: "Data e ora ritiro",
      passengers: "Passeggeri",
      childSeats: "Seggiolini bambino",
      childSeatsNote: "Bambini sotto i 5 anni: portare il proprio seggiolino.",
      pet: "Animale",
      luggage: "Bagagli",
      luggagePh: "Numero e dimensione dei bagagli",
      name: "Nome completo",
      email: "Email",
      phone: "Telefono (+41 o internazionale)",
      notes: "Note",
      notesPh: "Numero volo, richieste speciali…",
      submit: "Invia prenotazione",
      sending: "Invio in corso…",
      success: "Prenotazione ricevuta. Confermeremo a breve via WhatsApp o email.",
      errors: { required: "Compila tutti i campi obbligatori." },
    },
    contact: {
      title: "Contatti",
      whatsapp: "WhatsApp",
      phone: "Telefono",
      email: "Email",
      hours: "Prenotazioni · 09:00 – 19:30 CET, 7 giorni su 7",
    },
    footer: { rights: "Tutti i diritti riservati.", qr: "Scansiona per prenotare", langs: "Lingua" },
    kiosk: { title: "Menu a bordo", about: "Chi siamo", explore: "Esplora la regione", reserve: "Prenota" },
    common: { chf: "CHF", km: "km", min: "min", hour: "h", moreInfo: "Altro", back: "Indietro" },
  },
};
